import { render, staticRenderFns } from "./Register-1.vue?vue&type=template&id=6bc6e9e7&scoped=true&"
import script from "./Register-1.vue?vue&type=script&lang=js&"
export * from "./Register-1.vue?vue&type=script&lang=js&"
import style0 from "./Register-1.vue?vue&type=style&index=0&id=6bc6e9e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6e9e7",
  null
  
)

export default component.exports